import { createContext, useCallback, useContext, useState } from 'react';
import {
  Container,
  Title,
  Content,
  ImgOwl,
  ContainerButtons,
  Button,
  TextButton,
  Message,
} from '../components/PopupBasic/styles';
import { Modal } from 'antd';

import { typeOwl } from '../interfaces/pet';

export interface ButtonProps {
  buttonText: string;
  isPurple?: boolean;
  buttonFunction?: () => void;
}

export interface PopupProps {
  title?: string;
  message?: string;
  buttons?: ButtonProps[];
  type?: string;
}

interface PopupContextData {
  mountPopup: (properties: PopupProps) => void;
}

const PopupContext = createContext({} as PopupContextData);

const PopupProvider: React.FC = ({ children }) => {
  const [modalActive, setModalActive] = useState(false);
  const [modalProps, setModalProps] = useState<PopupProps>({} as PopupProps);

  const mountPopup = useCallback((properties: PopupProps) => {
    setModalActive(true);
    setModalProps(properties);
  }, []);

  const customStyles = {
    content: {
      padding: 0,
    },
    window: {
      maxWidth: '90vw',
    },
  };

  return (
    <PopupContext.Provider
      value={{
        mountPopup,
      }}
    >
      {children}
      <Modal
        title={null}
        footer={null}
        visible={modalActive}
        bodyStyle={customStyles.content}
        style={customStyles.window}
        onCancel={() => setModalActive(false)}
        maskClosable={false}
      >
        <Container>
          <Content>
            {modalProps.title && <Title>{modalProps.title} </Title>}
            {modalProps.type && (
              <ImgOwl
                style={{ height: '20vh' }}
                src={typeOwl[modalProps.type]}
              />
            )}
            {modalProps.message && <Message>{modalProps.message}</Message>}
          </Content>
          <ContainerButtons>
            {modalProps.buttons &&
              modalProps.buttons.map((item, index) => {
                return (
                  <Button
                    key={index}
                    isPurple={item.isPurple}
                    onClick={() => {
                      setModalActive(false);
                      if (item.buttonFunction) item.buttonFunction();
                    }}
                  >
                    <TextButton>{item.buttonText}</TextButton>
                  </Button>
                );
              })}
          </ContainerButtons>
        </Container>
      </Modal>
    </PopupContext.Provider>
  );
};

function usePopup(): PopupContextData {
  const context = useContext(PopupContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export { PopupProvider, usePopup };
